module.exports = __webpack_public_path__ + "img/info-clock.463166db.svg";